/* eslint-disable import/prefer-default-export */
export enum CourseLandingTab {
  Overview = 'overview',
  LiveClass = 'live_class',
  WhatsNext = 'whats_next',
  PremiumSessions = 'premium_sessions',
}
